import { useState } from "react";
import { Navigate } from "react-router";

import { consumePostLoginRedirectPath } from "./auth-session-storage";

/**
 * Reads the post-login redirect destination from sessionStorage (set by auth-guard and before Kinde's OAuth redirect wipes in-memory router state) and navigates there after login.
 */
export const AuthLoginRedirect = () => {
	// Uses a state hook to read the redirect path from sessionStorage and remove it after reading so that the redirect path is only read once and then removed from sessionStorage because in React StrictMode, the component will be rendered twice and would immediately redirect to the dashboard again because this would run twice, set the sessionStorage item correctly and then immediately remove it again which would default to the dashboard with the second render.
	const [redirectPath] = useState(() => consumePostLoginRedirectPath());

	return <Navigate replace to={redirectPath} />;
};
